const FavoriteIcon = ({
  filled,
  size = 17
}: {
  filled?: boolean;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.11748 3.89769C7.06116 2.70077 5.34855 2.70077 4.29223 3.89769C3.23592 5.09461 3.23592 7.0352 4.29223 8.23212L8.5 13L12.7078 8.23212C13.7641 7.0352 13.7641 5.09461 12.7078 3.89769C11.6515 2.70077 9.93884 2.70077 8.88252 3.89769L8.5 4.33113L8.11748 3.89769Z"
        stroke="#0E0E0E"
        fill={filled ? "#0E0E0E" : "none"}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FavoriteIcon;
